import { Grid } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/ErrorOutlineOutlined';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styles } from './force-signoff-dialogue-styles';

const ForceSignoffDialogue: React.FC = (): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid>
          <WarningIcon classes={{ root: `${classes.iconWarning}` }} />
        </Grid>
        <Grid>
          <p className={classes.title}>{t('Lock_ForceSignOff')}</p>
          <p className={classes.message}>{t('ActiveTransaction')}</p>
          <p className={classes.message}>{t('DecisionToForceSignOff')}</p>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ForceSignoffDialogue;
